import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["propertyUtilityId"],
  _excluded2 = ["propertyUtilityId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { propertyUtilityRoutes } from './routes';
export class PropertyUtility {
  constructor() {
    _defineProperty(this, "routes", propertyUtilityRoutes);
  }
  async addPropertyUtilityConfiguration(data, options) {
    const resp = await requestService('property').post(this.routes.propertyUtilitiesAdd(data.propertyId), _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async addPropertyUtilitiesConfigurationBatch(data, options) {
    const resp = await requestService('property').post(this.routes.propertyUtilitiesConfiguration(data.propertyId), {
      propertyUtilities: data.propertyUtilities
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getGwdHistory(data, options) {
    const resp = await requestService('property').post(this.routes.gwdHistory, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertyUtilityConfiguration(data, options) {
    const resp = await requestService('property').put(this.routes.propertyUtilities(data.propertyUtilityId), _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deletePropertyUtilityConfiguration(data, options) {
    const resp = await requestService('property').delete(this.routes.propertyUtilities(data.propertyUtilityId), _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertyUtilitiesConfigurationBatch(data, options) {
    const resp = await requestService('property').put(this.routes.baseUrl, {
      propertyUtilities: data.propertyUtilities
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createPropertyUtilitiesBatch(data, options) {
    const resp = await requestService('property').post(this.routes.propertyUtilityBatch, {
      propertyId: data.propertyId,
      propertyUtilities: data.propertyUtilities
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertyUtilitiesBatch(data, options) {
    const resp = await requestService('property').put(this.routes.propertyUtilityBatchUpdate, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyUtilityInfoByUtilityAndProperty(data, options) {
    const resp = await requestService('property').post(this.routes.propertyUtilityInfo, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getPropertyUtilitiesByPropertyId(data, options) {
    const resp = await requestService('property').get(this.routes.propertyUtilities(data.propertyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deletePropertyUtility(data, options) {
    const resp = await requestService('property').delete(this.routes.propertyUtilityById(data.propertyUtilityId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updatePropertyUtility(data, options) {
    const resp = await requestService('property').put(this.routes.propertyUtilityById(data.propertyUtilityId), data.propertyUtilities, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateSubmeterConfig(data, options) {
    const propertyUtilityId = data.propertyUtilityId,
      body = _objectWithoutProperties(data, _excluded);
    const resp = await requestService('property').put(this.routes.submeterConfig(propertyUtilityId), _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getSubmeterConfigV2(data, options) {
    const resp = await requestService('property').get(this.routes.submeterConfigV2(data.propertyUtilityId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateCsvColumnMap(data, options) {
    const propertyUtilityId = data.propertyUtilityId,
      body = _objectWithoutProperties(data, _excluded2);
    const resp = await requestService('property').patch(this.routes.csvColumnMap(propertyUtilityId), _objectSpread({}, body), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}